export default __webpack_public_path__ + "static/media/welcome_inicio.9c5d79d7.png";